import React from 'react'
import { SelectWrapper } from '../components/shared/select/SelectWrap'
import zipcodes from './bpostSelect.json'
import CreatableSelect from 'react-select/lib/Creatable'
import {components as reactSelectComponents, createFilter} from 'react-select'
import styles from './bpostSelect.scss'

const options = zipcodes.map(({zip, city}) => {
	const search = city.toLowerCase().split(/[^a-z]+/).join('|')
	return {
		value: `${zip}_${city}`,
		label: `${zip}, ${city}`,
		search: `|${zip}|${search}`,
	}
})

const matcher = filter => option => {
	const l = `|${filter.toLowerCase().replace(/[^a-z0-9]/, '|')}`
	return option.search.includes(l)
}

const filterOptions = (options, filter) =>
	filter ? options.filter(matcher(filter)) : []

export const BpostSelect = (props) => (
	<SelectWrapper
		{...props}
		isSearchable
		isClearable
		onBlur={() => props.onBlur()}
		options={options}
		filterOptions={filterOptions}
	/>
)


let selectInFocusWithin = false

export const customCreatableSelectStyles = {
    control: (base, state) => {
        selectInFocusWithin = state.isFocused
        return {
        ...base,
        flex: "4",
        fontSize: "1em",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        color: "#000",
        backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
        borderColor: "#d9d9d9 #ccc #b3b3b3",
        borderRadius: "2px",
        border: "1px solid #d9d9d9",
        minHeight: "25px",
        maxHeight: "auto",
        //height: state.isFocused ? "auto" : "25px",
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        "&:focus": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        padding: 0,
        margin: 0,
        overflow: state.isFocused ? null : "hidden"
      }},
      menu: base => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word",
      }),
      menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline"
      }),
      singleValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        color: "black",
        fontSize: "0.8em",
      }),
      /* noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        height: "20px",
        lineHeight: "16px"
      }), */
      option: (base, state) => ({
        ...base,
        padding: 0,
        fontSize: '0.8em',
        maxHeight: "25px"
      }),
      valueContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        top: 0
      }),
      clearIndicator: (base, state) => ({
        ...base,
        padding: 0
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        marginTop: 0,
        padding: 0
      }),
      indicatorsContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "23px",
        top: 0
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0
      }),
      group: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
      }),
      groupHeading: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
      }),
      input: (base, state) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '0.8em',
        lineHeight: '1.1em',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        }
      }),
      noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '0.8em'
      }),
      placeholder: (base, state) => ({
        ...base,
        fontSize: '0.8em',
        lineHeight: '1.1em'
      })
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const DropdownIndicator = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.DropdownIndicator {...props}>
        <span className={styles.downArrowHolder}>
                <span className={styles.downArrow}></span>
        </span>
      </reactSelectComponents.DropdownIndicator>
    )
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.NoOptionsMessage {...props}>
        {_('noOptions')}
      </reactSelectComponents.NoOptionsMessage>
    )
}

export const BpostSelectCreatable = (props) => (
    <CreatableSelect
        {...props}
        placeholder=""
        options={options}
        isClearable
        isSearchable
        isMulti={false}
        onBlur={() => props.onBlur()}
        onBlurResetsInput={false}
        styles={customCreatableSelectStyles}
        components={{ DropdownIndicator, NoOptionsMessage }}
        formatCreateLabel={(value)=>`${props.createLabel} ${value}`}
        filterOption={createFilter({
            ignoreCase: true,
            ignoreAccents: true,
            trim: true,
            // matchFrom: 'start',
        })}
        value={(props.value && props.value.value)}
        onChange={(value) => (props.onChangeOther(value))}
    />

)

export const BpostInput = (props) => (
    <input
        {...props}
        type="text"
        className={props.className}
        onChange={props.onChange}
    />
)

export default BpostSelect



// WEBPACK FOOTER //
// ./components/bpostSelect.jsx